var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58667 4.96065C0.626667 5.38732 0 6.34732 0 7.40065V13.6673C0 21.0673 5.12 27.9873 12 29.6673C18.88 27.9873 24 21.0673 24 13.6673V7.40065C24 6.34732 23.3733 5.38732 22.4133 4.96065L13.08 0.813984C12.3867 0.507318 11.6 0.507318 10.92 0.813984L1.58667 4.96065ZM12 8.33398C12.7333 8.33398 13.3333 8.93398 13.3333 9.66732C13.3333 10.4007 12.7333 11.0007 12 11.0007C11.2667 11.0007 10.6667 10.4007 10.6667 9.66732C10.6667 8.93398 11.2667 8.33398 12 8.33398ZM12 13.6673C12.7333 13.6673 13.3333 14.2673 13.3333 15.0007V20.334C13.3333 21.0673 12.7333 21.6673 12 21.6673C11.2667 21.6673 10.6667 21.0673 10.6667 20.334V15.0007C10.6667 14.2673 11.2667 13.6673 12 13.6673Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.8f6eb0bf0f62c00fa854b89f11f03ffc.svg";
export { ForwardRef as ReactComponent };